module.exports = __webpack_public_path__ + "img/DE00296.a23ec874.png";